/* @sravni/react-header version 0.2.43 */
/** Hardcode custom  styles for menu icons (these customization are not in the sitesettings yet) */
var customIcons = [
    {
        label: 'Ипотека в новостройках ПИК',
        href: '/special/pik/?promo=1',
        style: { padding: '6px' }
    },
    {
        label: 'Онлайн-курсы Skillbox',
        href: '/kursy/shkola/skillbox/',
        style: { background: '#3D3BFF', padding: '8px' }
    },
];
var customIconsMap = function () {
    return customIcons.reduce(function (acc, icon) {
        acc[icon.href] = icon.style;
        return acc;
    }, {});
};
var getCustomIconStyles = function (href) {
    var icons = customIconsMap();
    return icons[href] || {};
};

export { customIcons, getCustomIconStyles };
//# sourceMappingURL=customIcons.js.map
